<mat-slide-toggle [checked]="visible" (change)="visibilityToggled($event)">
  <div class="toggle-text" *ngIf="visible">
    <ng-container *ngIf="visTable">ON</ng-container>
    <ng-container *ngIf="!visTable">Visible on dashboard</ng-container>
  </div>
  <div class="toggle-text" *ngIf="!visible">
    <ng-container *ngIf="visTable">OFF</ng-container>
    <ng-container *ngIf="!visTable">Hidden on dashboard</ng-container>
  </div>
</mat-slide-toggle>
